// eslint-disable-next-line no-undef
__webpack_public_path__ = window.SERVERLESS_INJECT_PUBLIC_PATH || '/';